import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/holiday/high-comm-check`;

export const HIGH_COMM_CHECK_START_BANNER = `${ROOT}/start-banner-v2.png`;
export const HIGH_COMM_CHECK_PENDING_BANNER = `${ROOT}/pending-banner-v4.png`;
export const HIGH_COMM_CHECK_SUCCESS_BANNER = `${ROOT}/success-banner-v2.png`;

export const HIGH_COMM_PROCESS_INFO = `${ROOT}/process-info.png`;
export const HIGH_COMM_PRODUCT_CARD_PREVIOUS_BG = `${ROOT}/previous-bg.png`;
export const HIGH_COMM_PRODUCT_CARD_UPGRADE_BG = `${ROOT}/upgrade-bg.png`;
export const HIGH_COMM_CHECK_LOADING_ICON = `${ROOT}/check-loading-icon.gif`;
export const HIGH_COMM_CHECK_BTN_BOTTOM = `${ROOT}/btn-bottom.svg`;
export const HIGH_COMM_CHECK_BTN_TOP = `${ROOT}/btn-top.svg`;
export const HIGH_COMM_CHECK_TROPHY = `${ROOT}/trophy.svg`;
export const HIGH_COMM_CHECK_EXCHANGE = `${ROOT}/exchange.svg`;
export const HIGH_COMM_CHECK_FIRE = `${ROOT}/fire.svg`;
export const HIGH_COMM_CHECK_RESULT_SUCCESS = `${ROOT}/success.png`;

export const HIGH_COMM_CHECK_DOWN_ICON = `${ROOT}/down-icon.svg`;

export const HIGH_COMM_CHECK_TOP_FLOWER = `${ROOT}/top-flower-icon.svg`;
export const HIGH_COMM_CHECK_BOTTOM_FLOWER = `${ROOT}/bottom-flower-icon.svg`;
export const HIGH_COMM_CHECK_RIGHT_ARROW = `${ROOT}/right-arrow-icon.svg`;
